import React from 'react';
import { Section, FadeIn, CountdownTimer, CTAButton } from './Shared';
import { ShieldCheckIcon, ClockIcon, LockIcon } from 'lucide-react';
export const FinalCTA = () => {
  const costComparison = [{
    sin: '3-5 horas/semana planificando desde cero',
    con: '10 min/semana. El resto es enseñar.',
    iconSin: '⏰',
    iconCon: '⚡'
  }, {
    sin: 'Siempre los mismos ejercicios → las alumnas se aburren',
    con: '100+ ejercicios distintos → siempre hay algo nuevo',
    iconSin: '😓',
    iconCon: '🤩'
  }, {
    sin: 'Alumnas que abandonan sin saber por qué',
    con: 'Sistema de progresión de 90 días → retención visible',
    iconSin: '💸',
    iconCon: '📈'
  }, {
    sin: 'Sin progresión clara de nivel a nivel',
    con: '6 tomos con progresión estructurada → mejoran y se quedan',
    iconSin: '📋',
    iconCon: '🎯'
  }, {
    sin: 'Alumna embarazada o con lesión = pánico o improvisación',
    con: 'Tomo 5 → protocolo exacto para cada condición especial',
    iconSin: '😨',
    iconCon: '🧘‍♀️'
  }, {
    sin: 'Niveles mezclados = caos de clase',
    con: 'Variaciones en 3 niveles → todas mejoran juntas',
    iconSin: '👥',
    iconCon: '✨'
  }, {
    sin: 'Sin sistema de comunicación con alumnas',
    con: '30 días de contenido para Instagram listo para publicar',
    iconSin: '📱',
    iconCon: '🚀'
  }, {
    sin: 'Sin identidad profesional visible',
    con: 'Sistema que justifica cobrar lo que merecés',
    iconSin: '💼',
    iconCon: '💎'
  }];
  return <Section bg="cream" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <FadeIn className="text-center mb-6 md:mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-extrabold text-charcoal mb-3 md:mb-4" data-id="element-14">
            GAP 360™
          </h2>
          <p className="text-lg md:text-2xl font-bold text-gray-600 mb-1 md:mb-2" data-id="element-15">
            El próximo lunes podés volver a improvisar la clase.
          </p>
          <p className="text-lg md:text-2xl font-bold text-coral mb-4 md:mb-8" data-id="element-16">
            O podés entrar al estudio con todo resuelto desde hoy.
          </p>
          <h3 className="text-2xl md:text-3xl font-extrabold text-charcoal" data-id="element-17">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </FadeIn>

        {/* Desktop table */}
        <FadeIn className="mb-12 md:mb-20 hidden md:block overflow-x-auto pb-4" data-id="element-18">
          <table className="w-full min-w-[600px] border-collapse bg-white shadow-xl rounded-2xl overflow-hidden" data-id="element-19">
            <thead data-id="element-20">
              <tr className="bg-charcoal text-white" data-id="element-21">
                <th className="p-4 text-left font-bold w-1/2 text-gray-400" data-id="element-22">
                  SIN GAP 360
                </th>
                <th className="p-4 text-left font-bold w-1/2 text-coral" data-id="element-23">
                  CON GAP 360
                </th>
              </tr>
            </thead>
            <tbody data-id="element-24">
              {costComparison.map((row, i) => <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50" data-id="element-25">
                  <td className="p-4 text-gray-500" data-id="element-26">
                    <span className="mr-2" data-id="element-27">{row.iconSin}</span> {row.sin}
                  </td>
                  <td className="p-4 text-charcoal font-bold bg-coral/5" data-id="element-28">
                    <span className="mr-2" data-id="element-29">{row.iconCon}</span> {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>

        {/* Mobile stacked cards */}
        <FadeIn className="mb-8 md:hidden space-y-2.5" data-id="element-30">
          {costComparison.map((row, i) => <div key={i} className="bg-white rounded-xl p-3 shadow-sm border border-gray-100" data-id="element-31">
              <div className="flex items-start gap-2 mb-1.5 text-gray-500" data-id="element-32">
                <span className="text-sm" data-id="element-33">{row.iconSin}</span>
                <p className="text-xs line-through" data-id="element-34">{row.sin}</p>
              </div>
              <div className="flex items-start gap-2 bg-coral/5 rounded-lg p-2" data-id="element-35">
                <span className="text-sm" data-id="element-36">{row.iconCon}</span>
                <p className="text-charcoal font-bold text-xs" data-id="element-37">{row.con}</p>
              </div>
            </div>)}
        </FadeIn>

        <FadeIn className="bg-white p-4 md:p-12 rounded-2xl md:rounded-3xl shadow-2xl border-2 border-coral/20 text-center" data-id="element-38">
          <div className="inline-block bg-red-100 text-red-600 font-bold px-4 md:px-6 py-1.5 md:py-2 rounded-full text-xs md:text-sm uppercase tracking-wider mb-4 md:mb-6 animate-pulse" data-id="element-39">
            ⏳ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </div>
          <CountdownTimer data-id="element-40" />
          <p className="text-gray-600 font-semibold text-sm md:text-base mt-3 md:mt-4 mb-5 md:mb-8" data-id="element-41">
            Después sube $8.000 ARS y no vuelve a bajar.
          </p>

          <div className="space-y-4 md:space-y-6 mb-6 md:mb-8" data-id="element-42">
            <div className="p-4 md:p-6 border border-gray-200 rounded-xl md:rounded-2xl hover:border-coral transition-colors" data-id="element-43">
              <h4 className="text-lg md:text-xl font-bold text-charcoal mb-1 md:mb-2" data-id="element-44">
                📘 GAP 360 — SISTEMA COMPLETO
              </h4>
              <p className="text-gray-500 text-sm mb-3 md:mb-4" data-id="element-45">
                6 Tomos + 6 Bonos
              </p>
              <div className="flex items-center justify-center gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-46">
                <span className="text-gray-400 line-through font-bold text-sm md:text-base" data-id="element-47">
                  $34.990
                </span>
                <span className="text-xl md:text-2xl font-extrabold text-coral" data-id="element-48">
                  $19.990
                </span>
              </div>
              <CTAButton fullWidth href="https://checkout.rincondigital.shop/cart/54038795223315:1" data-id="element-49">
                → QUIERO MI GAP 360 AHORA
              </CTAButton>
            </div>

            <div className="p-4 md:p-6 border-2 border-gold rounded-xl md:rounded-2xl bg-charcoal text-white relative" data-id="element-50">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-gold text-charcoal font-bold px-4 py-1 rounded-full text-xs" data-id="element-51">
                MÁS COMPLETO
              </div>
              <h4 className="text-lg md:text-xl font-bold text-gold mb-1 md:mb-2 mt-2" data-id="element-52">
                🏆 GAP 360 ROSE GOLD EDITION™
              </h4>
              <p className="text-gray-300 text-xs md:text-sm mb-3 md:mb-4" data-id="element-53">
                6 Tomos + 6 Bonos + GAP PREMIUM (Periodización 6 meses) +
                Academia GAP Digital
              </p>
              <div className="flex items-center justify-center gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-54">
                <span className="text-gray-400 line-through font-bold text-sm md:text-base" data-id="element-55">
                  $43.990
                </span>
                <span className="text-xl md:text-2xl font-extrabold text-white" data-id="element-56">
                  $27.990
                </span>
              </div>
              <a href="https://checkout.rincondigital.shop/cart/54038795419923:1" className="block w-full bg-gradient-to-r from-gold to-yellow-600 text-charcoal font-heading font-extrabold text-base md:text-lg py-3 md:py-4 px-6 md:px-8 rounded-full shadow-lg hover:shadow-xl transition-all text-center" data-id="element-57">
                → QUIERO EL GAP 360 ROSE GOLD EDITION
              </a>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 text-xs md:text-sm font-semibold text-gray-600" data-id="element-58">
            <div className="flex items-center gap-1" data-id="element-59">
              <LockIcon size={14} className="text-green-500" data-id="element-60" /> Pago 100% seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-61">
              <ClockIcon size={14} className="text-blue-500" data-id="element-62" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-1" data-id="element-63">
              <ShieldCheckIcon size={14} className="text-coral" data-id="element-64" /> Garantía 7
              días
            </div>
          </div>
          <div className="mt-3 md:mt-4 text-xs md:text-sm text-gray-500 font-bold" data-id="element-65">
            Mercado Pago | Tarjeta | Transferencia
          </div>
        </FadeIn>
      </div>
    </Section>;
};